export class TabTitleAnimator {
    private originalTitle: string = "PhoneHQ - Business Phone App";
    private animationInterval: number | null = null;
    private isAnimating: boolean = false;
    private newMessageTitle: string = "";

    constructor() {
        document.addEventListener('visibilitychange', () => {
            if (!document.hidden) {
                this.stop();
            }
        });

        document.addEventListener('click', () => {
            this.stop();
        });
    }

    start(senderDisplayName: string) {
        this.stop();

        this.newMessageTitle = `New message - ${senderDisplayName}`;
        this.isAnimating = true;

        const fullText = `${this.newMessageTitle} | ${this.originalTitle} | `;
        let position = 0;

        this.animationInterval = setInterval(() => {
            const displayText = fullText.substring(position) + fullText.substring(0, position);
            document.title = displayText.substring(0, fullText.length - 3);

            position++;
            if (position >= fullText.length) {
                position = 0;
            }
        }, 200);
    }

    stop() {
        if (this.animationInterval) {
            clearInterval(this.animationInterval);
            this.animationInterval = null;
        }
        this.isAnimating = false;
        document.title = this.originalTitle;
    }

    setOriginalTitle(title: string) {
        this.originalTitle = title;
        if (!this.isAnimating) {
            document.title = title;
        }
    }
}
